var saramahLocale = function(e) {
  if (e.target.className != 'locale-selectors__container')
    return;
  
  $(document).unbind('DOMNodeInserted', saramahLocale);
  
  let countryVal = $('select[name="country_code"]').val();
  let languageVal = $('select[name="locale_code"]').val();
  
  
  $('.saramah-localization').append($('.locale-selectors__container').clone());
  
  
  $('.locale-selectors__container').on('change', function() {
      $(this).find('form').submit();
  });

  $('select[name="country_code"]').val(countryVal);
  $('select[name="locale_code"]').val(languageVal);
}

$(document).bind('DOMNodeInserted', saramahLocale);

document.addEventListener("DOMContentLoaded", function() {
    if(Shopify.locale == "ar") {
       document.getElementsByTagName("html")[0].style.direction = "rtl";
       document.getElementsByTagName("body")[0].style['text-align'] = "right";
    }
  });

if (Shopify.currency.active==='EUR' && (['de','fr','es','it','fi']).includes(Shopify.locale)) {
  $('.price-box').each((a, b) => b.innerText = b.innerText.replace('€', '') + ' €');
  $('.price').each((a, b) => b.innerText = b.innerText.replace('€', '') + ' €');
  $('.price-regular').each((k,a)=>a.innerText = a.innerText.replace('€', '') + ' €');
  $('.price-unit').each((k,a)=>a.innerText = a.innerText.replace('€', '') + ' €');

  let price = document.querySelector("#sticky-wrapper > div > div.main-menu.jas-mb-style > div.container > div > div > div > div.mb-area.header-bottom-left > nav > ul > li:nth-child(1) > div > div.site-nav-dropdown.style_1 > div > div > div.col-12.col-xl-5 > div > div.mega-col.col-left > div > div > div.product-bottom > div.price-box > div > span");
  if (price)
    price.innerText = price.innerText.replace('€', '') + ' €';
}

// if (Shopify.locale === 'de')
//   document.querySelector("span.stamped-badge-caption > span").innerText = " Kundenrezensionen";

// if (Shopify.locale === 'fr')
//   document.querySelector("span.stamped-badge-caption > span").innerText = " commentaires des clients";

function walkText(node) {
  if (node.nodeType == 3) {
    node.data = node.data.replace(/®/g, "™");
    node.data = node.data.replace(/30 ml/g, "1 fl. oz.");
    node.data = node.data.replace(/100 ml/g, "3.4 fl. oz.");
    node.data = node.data.replace(/200 ml/g, "6.8 fl. oz.");
  }
  if (node.nodeType == 1 && node.nodeName != "SCRIPT") {
    for (var i = 0; i < node.childNodes.length; i++) {
      walkText(node.childNodes[i]);
    }
  }
}

if (Shopify.country == 'US') {
  walkText(document.body);
  $(document).bind('DOMNodeInserted', ()=>walkText(document.body));
}



// language path prefix

// let url_object = new URL(window.location.href);
// let parts = url_object.pathname.split("/");
// let path = parts[1];

// if (path.length < 6 ) {
//   const links = document.querySelectorAll('.swatch-group a');

//   if (links)
//     links.forEach(link => {
//       link.href = '/' + path + link.getAttribute('href');
//     });
// }
